import { z } from 'zod';
import { isNil } from 'lodash';
import { Paths } from 'type-fest';

import { AgeWithinValues } from './types';
import { addCustomIssue as addIssue } from '../../utils';

export const ageWithinSchema = z
  .object({
    minimumAge: z.number().int().nullable().optional(),
    maximumAge: z.number().int().nullable().optional(),
  })
  .superRefine(({ minimumAge, maximumAge }, ctx) => {
    if (!isNil(minimumAge) && !isNil(maximumAge) && minimumAge >= maximumAge) {
      addIssue(
        ctx,
        'minimumAge' satisfies Paths<AgeWithinValues>,
        'Minimum age must be less than maximum age',
      );
      addIssue(
        ctx,
        'maximumAge' satisfies Paths<AgeWithinValues>,
        'Maximum age must be greater than minimum age',
      );
    }
  })
  .optional();
